import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { Box, Stack, useTheme } from '@hermes/web-components'

const ImageResizableSkeleton = () => {
  const theme = useTheme()
  const { down } = theme.breakpoints
  const MAX_TOTAL_HEIGHT = 209
  const MAX_IMAGE_WIDTH = 130
  const MAX_HEIGHT_MOBILE = 105
  const MAX_WIDTH_MOBILE = 65

  return (
    <Box
      sx={{
        height: MAX_TOTAL_HEIGHT,
        width: MAX_IMAGE_WIDTH,
        [down('sm')]: { height: MAX_HEIGHT_MOBILE, width: MAX_WIDTH_MOBILE }
      }}
      flexShrink={0}
      position={'relative'}
    >
      <Skeleton height="100%" width="100%" borderRadius="4px" />
    </Box>
  )
}

export const SearchResultHorizontalSkeleton = () => {
  const theme = useTheme()
  const { down, up } = theme.breakpoints

  return (
    <Box width={'100%'} height={'100%'} justifyContent={'space-between'} padding={'12px'} gap="16px" display="flex">
      <Box display="flex" gap="16px">
        <ImageResizableSkeleton />
        <Stack justifyContent="space-evenly" spacing={3} display="flex" width={'100%'}>
          <Box>
            <Skeleton width={200} height={24} />
            <Skeleton width={150} height={16} />
          </Box>

          <Box sx={{ [down('sm')]: { display: 'none' } }}>
            <Skeleton width="100%" height={48} />
          </Box>
          <Box display="inline-flex" gap="8px" sx={{ [down('xs')]: { display: 'none' } }}>
            <Skeleton width={100} height={20} />
            <Skeleton width={40} height={20} />
          </Box>
        </Stack>
      </Box>
      <Box
        alignContent={'center'}
        alignItems={'center'}
        sx={{ [up('md')]: { display: 'none' } }}
        key={'purchase button'}
      >
        <Skeleton width={60} height={40} borderRadius={40} />
      </Box>
      <Box
        alignContent={'center'}
        alignItems={'center'}
        sx={{ [down('md')]: { display: 'none' } }}
        key={'variantsModal'}
      >
        <Skeleton width={300} height={100} borderRadius={12} />
      </Box>
    </Box>
  )
}
